// apps/account-portal/src/components/PageContainer.tsx
import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, className = '' }) => (
  <div className={`max-w-[1360px] mx-auto px-4 md:px-8 py-6 pb-32 ${className}`}>
    {children}
  </div>
);

export default PageContainer;
